module.exports = __webpack_public_path__ + "static/img/TOSCANA-JAVA-GLOW.36bc851.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/TOSCANA-JAVA-GLOW.png
// module id = 4pBK
// module chunks = 0